export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}skill/skill-proficiency/:id`;

    return $resource(url, { id: '@id' }, {
        query: { method: 'GET', url, isArray: true },
        get: { method: 'GET', url },
        save: { method: 'POST', url },
        update: { method: 'PUT', url },
        delete: { method: 'DELETE', url }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Proficiency/index.js